export default {"src":"/komodo/_next/static/media/btc.e4d28927.svg","height":30,"width":82,"blurWidth":0,"blurHeight":0};